/**
 * Period settings for v2's table components. v2's own: there is no fallback to another app's
 * store - a v2 table is always inside V2Table, which provides them.
 */

import { createContext, useContext, type ReactNode } from 'react';
import type { TablePeriodSettings } from './periods';

export type TableSettings = TablePeriodSettings;

interface TableSettingsValue {
  settings: TableSettings | undefined;
  isRecalculating: boolean;
}

const TableSettingsContext = createContext<TableSettingsValue>({ settings: undefined, isRecalculating: false });

export function TableSettingsProvider({
  settings,
  isRecalculating = false,
  children,
}: {
  settings: TableSettings | undefined;
  isRecalculating?: boolean;
  children: ReactNode;
}) {
  return (
    <TableSettingsContext.Provider value={{ settings, isRecalculating }}>{children}</TableSettingsContext.Provider>
  );
}

export function useTableSettings(): TableSettingsValue {
  return useContext(TableSettingsContext);
}
